import { ContextMenu as RadixContextMenu } from '@radix-ui/themes';
import cn from 'classnames';

import { SEPARATOR_TITLE, getFlyToRadixColor, renderIcon } from '../utils';
import { ContextMenuProps } from './ContextMenu.types';

export function ContextMenu({
  children,
  items,
  className,
  size,
  ...props
}: ContextMenuProps) {
  return (
    <RadixContextMenu.Root {...props}>
      <RadixContextMenu.Trigger>{children}</RadixContextMenu.Trigger>
      <RadixContextMenu.Content
        size={size}
        className={cn(className, 'flex flex-col gap-fly-3')}
      >
        <div className='flex flex-col gap-fly-3 !overflow-hidden'>
          {items.map((item, index) =>
            item.title === SEPARATOR_TITLE ? (
              <RadixContextMenu.Separator
                key={index}
                className='my-0 -mx-fly-3'
              />
            ) : (
              <RadixContextMenu.Item
                data-testid={`context-menu-item-${item.title.toLowerCase()}`}
                key={`${item.title}-${index}`}
                onClick={item.onClick}
                color={item.color ? getFlyToRadixColor(item.color) : undefined}
              >
                <div className='flex items-center gap-fly-3'>
                  {item.iconStart && renderIcon(item.iconStart, 16, 'mt-fly-1')}
                  {item.title}
                  {item.iconEnd && renderIcon(item.iconEnd, 16, 'mt-fly-1')}
                </div>
              </RadixContextMenu.Item>
            )
          )}
        </div>
      </RadixContextMenu.Content>
    </RadixContextMenu.Root>
  );
}
